/**
 * 統計(CSV)
 */
export class Statistics {
    /** 受付番号 */
    requestNo = ""
    /** 検体着日 */
    receiptOn = ""
    /** 納品予定日 */
    deliveryOn = ""
    /** 報告日 */
    reportOn: string[] = []
    /** 営業拠点 1:出雲 2:横浜 */
    salesOffice = ""
    /** 顧客区分 1:新規 2:既存 */
    customerClassification = ""
    /** 区分（官公庁・民間・検査会社）【未使用】 */
    industry = ""
    /** 顧客名 */
    customerName = ""
    /** グループ 【未使用】*/
    companyGroupName = ""
    /** 検体名称 */
    specimenName = ""
    /** 検査項目名 */
    inspectionName = ""
    /** 検査分類名 */
    classificationName = ""
    /** 金額 */
    amount = 0
    /** 検査員名 */
    inspectionUserName = ""
    /** 顧客郵便番号 */
    customerZipCode = ""
    /** 顧客住所（顧客住所１ + 顧客住所２） */
    customerAddress = ""
    /** 顧客部署名 */
    customerDepartment = ""
    /** 顧客担当者名 */
    customerContact = ""
    /** 顧客話番号 */
    customerTel = ""
    /** 顧客FAX番号 */
    customerFax = ""
    /** 顧客メールアドレス */
    customerMail = ""
    /** 代理店名 */
    agencyName = ""
    /** 代理店郵便番号 */
    agencyZipCode = ""
    /** 代理店住所（代理店住所１ + 代理店住所２） */
    agencyAddress = ""
    /** 代理店部署名 */
    agencyDepartment = ""
    /** 代理店担当者名 */
    agencyContact = ""
    /** 代理店話番号 */
    agencyTel = ""
    /** 代理店FAX番号 */
    agencyFax = ""
    /** 代理店メールアドレス */
    agencyMail = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Statistics>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new Statistics(JSON.parse(JSON.stringify(this)));
    }

    /**
     * CSV形式に変換
     */
    toCsv(separetor = ",") {
        const result: string[] = []

        result.push(this.requestNo)
        result.push(this.receiptOn.replace(/-/g, "/"))
        result.push(this.deliveryOn.replace(/-/g, "/"))
        result.push(this.reportOn.map(x => x.replace(/-/g, "/")).join(","))
        result.push(this.salesOffice)
        result.push(this.customerClassification)
        result.push(this.industry)
        result.push(this.customerName)
        result.push(this.companyGroupName)
        result.push(this.specimenName)
        result.push(this.inspectionName)
        result.push(this.classificationName)
        result.push(this.amount.toString())
        result.push(this.inspectionUserName)
        result.push(this.customerZipCode)
        result.push(this.customerAddress)
        result.push(this.customerDepartment)
        result.push(this.customerContact)
        result.push(this.customerTel)
        result.push(this.customerFax)
        result.push(this.customerMail)
        result.push(this.agencyName)
        result.push(this.agencyZipCode)
        result.push(this.agencyAddress)
        result.push(this.agencyDepartment)
        result.push(this.agencyContact)
        result.push(this.agencyTel)
        result.push(this.agencyFax)
        result.push(this.agencyMail)

        return result.map(x => x.replace(/"/g, '""'))
                     .map(x => `"${x}"`)
                     .join(separetor)
    }

    /**
     * CSVヘッダーを取得する
     */
    public static getHeader() {
        return [
            "受付番号",
            "検体着日",
            "納品予定日",
            "報告日",
            "営業拠点",
            "新規・既存",
            "区分（官公庁・民間・検査会社）",
            "顧客名",
            "グループ",
            "検体名称",
            "検査項目名",
            "検査分類名",
            "金額",
            "検査員名",
            "顧客郵便番号",
            "顧客住所",
            "顧客部署名",
            "顧客担当者名",
            "顧客話番号",
            "顧客FAX番号",
            "顧客メールアドレス",
            "代理店名",
            "代理店郵便番号",
            "代理店住所",
            "代理店部署名",
            "代理店担当者名",
            "代理店話番号",
            "代理店FAX番号",
            "代理店メールアドレス",
        ]
    }
}
